import React, { useState } from 'react';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import Label from '../../../common/Labels/Label';
import WorkspaceSelectionDropdown from '../../../common/WorkspaceSelectionDropdown/WorkspaceSelectionDropdown';

export const ModelTableFilterModal = ({
  workspaces = [],
  filter = { workspaces: [] },
  showDialog = false,
  onDialogToggle = () => {},
  onFilterConfirm = () => {},
  onClear = () => {},
}) => {
  const [selectedWorkspaces, setSelectedWorkspaces] = useState(filter.workspaces);

  const handleConfirmation = () => {
    onFilterConfirm({
      workspaces: selectedWorkspaces,
    });
  }

  return (
    <ConfirmationDialog
      title="Filter"
      confirmButtonText="Apply"
      cancelButtonText="Clear All"
      modalAnimationKey="model-admin-table-filter"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      onConfirm={handleConfirmation}
      onCancel={onClear}
    >
      <div className="flex flex-col w-small-modal mx-2 my-3">
        <div className="flex flex-col m-1">
          <Label className="my-1" bold>Workspace</Label>
          <WorkspaceSelectionDropdown
            workspaces={workspaces}
            selectedWorkspaces={selectedWorkspaces}
            setSelectedWorkspaces={setSelectedWorkspaces}
          />
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default ModelTableFilterModal;
